function textVideoTogglePlayPause(element) {
  let video;
  if (element.tagName === 'VIDEO') {
    video = element;
  } else {
    const videoSection = element.closest('.aom-product-page-text-video-section');
    video = videoSection.querySelector('video');
  }

  if (video.paused) {
    video.play();
    const playButton = video
      .closest('.aom-product-page-text-video-section')
      .querySelector('.aom-custom-text-video-play-button');
    playButton.style.display = 'none';
  } else {
    video.pause();
    const playButton = video
      .closest('.aom-product-page-text-video-section')
      .querySelector('.aom-custom-text-video-play-button');
    playButton.style.display = 'flex';
  }
}

// NEW: attach listeners instead of inline onclick on the overlay
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aom-product-page-text-video-section').forEach((section) => {
    const video = section.querySelector('video');
    const playButton = section.querySelector('.aom-custom-text-video-play-button');

    // Initialize overlay visibility
    playButton.style.display = video.paused ? 'flex' : 'none';

    // Mouse / touch support
    playButton.addEventListener('click', () => textVideoTogglePlayPause(playButton));

    // Keyboard support (Enter / Space)
    playButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        textVideoTogglePlayPause(playButton);
      }
    });

    // Keep overlay in sync if playback changes from other sources
    video.addEventListener('play', () => {
      playButton.style.display = 'none';
      aomTrack('aom_text_video_play', {
        ui_element:  'text_video',
        action_type: 'play',
      });
    });
    video.addEventListener('pause', () => {
      playButton.style.display = 'flex';
      aomTrack('aom_text_video_pause', {
        ui_element:  'text_video',
        action_type: 'pause',
      });
    });

    video.addEventListener('click', () => textVideoTogglePlayPause(video));
  });
});
